import React from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Autocomplete,
} from "@mui/material";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { rows } from "./data";

const employeeNames = [...new Set(rows.map((row) => row.employeeName))];

const timePeriods = ["Today", "7 Days", "14 Days", "1 Month", "1 Year"];

const FilterItems = ({
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Employee Name
        </InputLabel>
        <Autocomplete
          disablePortal
          options={employeeNames}
          value={filterData.employeeName}
          onChange={handleChangeFilter("employeeName")}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              onKeyDown={(e) => {
                if (e.key === "Enter") handleFilter();
              }}
            />
          )}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Device ID
        </InputLabel>
        <TextField
          variant="outlined"
          name="deviceImei"
          value={filterData.deviceImei}
          onChange={handleChangeFilter("deviceImei")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Time Period
        </InputLabel>
        <FormControl fullWidth>
          <Select
            value={filterData.timePeriod}
            onChange={(e) => handleChangeFilter("timePeriod")(e)}
            variant="outlined"
            onKeyDown={(e) => {
              if (e.key === "Enter") handleFilter();
            }}
          >
            <MenuItem value="">All</MenuItem>
            {timePeriods.map((period) => (
              <MenuItem key={period} value={period}>
                {period}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={2}>
        <InputLabel> Total Orders (Min)</InputLabel>
        <TextField
          variant="outlined"
          name="totalOrdersMin"
          type="number"
          value={filterData.totalOrdersMin}
          onChange={handleChangeFilter("totalOrdersMin")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <InputLabel> Total Orders (Max)</InputLabel>
        <TextField
          variant="outlined"
          name="totalOrdersMax"
          type="number"
          value={filterData.totalOrdersMax}
          onChange={handleChangeFilter("totalOrdersMax")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <InputLabel> Order Lines (Min)</InputLabel>
        <TextField
          variant="outlined"
          name="orderLinesMin"
          type="number"
          value={filterData.orderLinesMin}
          onChange={handleChangeFilter("orderLinesMin")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <InputLabel> Order Lines (Max)</InputLabel>
        <TextField
          variant="outlined"
          name="orderLinesMax"
          type="number"
          value={filterData.orderLinesMax}
          onChange={handleChangeFilter("orderLinesMax")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <InputLabel> Total Items (Min)</InputLabel>
        <TextField
          variant="outlined"
          name="totalItemsMin"
          type="number"
          value={filterData.totalItemsMin}
          onChange={handleChangeFilter("totalItemsMin")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <InputLabel> Total Items (Max)</InputLabel>
        <TextField
          variant="outlined"
          name="totalItemsMax"
          type="number"
          value={filterData.totalItemsMax}
          onChange={handleChangeFilter("totalItemsMax")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12}>
        <Box textAlign="right">
          <Button
            variant="outlined"
            onClick={handleClearFilters}
            sx={{ mr: 1, color: "#7152F3" }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleFilter}
            sx={{ backgroundColor: "#7152F3" }}
          >
            Filter{" "}
            <ArrowForward fontSize="small" style={{ marginLeft: "5px" }} />
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FilterItems;
